import moment from "moment-timezone";
import dayjs from "dayjs";

export const formatDateTime = (inputDateTime) => {
  const date = moment(inputDateTime).format("MMM. DD. YYYY");
  const time = moment(inputDateTime).format("hh:mm a");
  return { date, time };
};

export function stringToDayJs(date) {
  return date ? dayjs(date) : null;
}

export function formatTimestampToServerDate(timestamp) {
  const date = new Date(timestamp);
  if (date.toString() === "Invalid Date") return "";

  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();

  return `${year}-${month}-${day}`;
}

export function formatIsoDateToReadable(isoDate) {
  if (!isoDate) return { date: "", time: "" }; // Перевірка, якщо дата відсутня

  const dateObject = dayjs(isoDate);

  // Формат для дати: Dec. 09. 2024
  const date = dateObject.format("MMM. DD. YYYY");

  // Формат для часу: 11:11 am
  const time = dateObject.format("hh:mm a");

  return { date, time };
}

export function formatUtcIso(isoString) {
  const d = new Date(isoString);
  const pad = (n) => n.toString().padStart(2, '0');

  const day   = pad(d.getUTCDate());
  const month = pad(d.getUTCMonth() + 1);
  const year  = d.getUTCFullYear();

  const hours   = pad(d.getUTCHours());
  const minutes = pad(d.getUTCMinutes());
  const seconds = pad(d.getUTCSeconds());

  const date =  `${day}.${month}.${year}`
  const time = `${hours}:${minutes}:${seconds}`


  return { date, time };
}


export const convertDate = (inputDate, dateType) => {
  const date = new Date(inputDate);
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();

  if (dateType === "DMY") {
    return `${day}.${month}.${year}`;
  }

  if (dateType === "YMD") {
    return `${year}-${month}-${day}`;
  }

  if (dateType === "HM") {
    return `${hours}:${minutes}`;
  }
};

export const getDaysDifference = (targetDateStr) => {
  let targetDate = new Date(targetDateStr);

  let currentDate = new Date();

  let differenceInTime = targetDate - currentDate;

  return Math.ceil(differenceInTime / (1000 * 60 * 60 * 24));
}